import React from 'react'
import { string, object } from 'prop-types'

class ReviewItem extends React.Component {
  getMonth (month) {
    const { lang } = this.props
    const months = {
      'en': [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
      'de': [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ]
    }
    return months[lang][ parseInt(month, 10) ]
  }

  formatDateToLongDate (date) {
    if (!date) return ''
    date = date.split('-')
    const year = date[0]
    const month = this.getMonth((date[1] - 1))
    const day = date[2]
    return day + ' ' + month + ' ' + year
  }

  render () {
    const { item, search } = this.props
    const {
      sid,
      comment_date: commentDate,
      name,
      product_name: productName,
      score
    } = item
    let { comment } = item
    if (search) {
      const commentWords = comment.toLowerCase().split(RegExp('(' + search + '+)', 'gi'))
      comment = commentWords.filter(commentItem => {
        return commentItem || false
      }).map((commentItem, i) => {
        if (commentItem === search.toLowerCase()) return (<strong key={i}>{ search }</strong>)
        return (<span key={i}>{ commentItem }</span>)
      })
    }
    return (
      <p className='comment'>
        <strong className='db item'>
          <span>{ productName }</span>
        </strong>
        <span className='review-quote'>
          <span className='commentSect' />
          <span className='description'>{ comment }</span>
        </span>
        <span className='commentSectEnd' title={sid} />
        <strong className='cite reviewer'>{ name } </strong>
        <strong className='cite dtreviewed'> { this.formatDateToLongDate(commentDate) }<span className='value-title' title={commentDate} /></strong>
        <span className='cite'> (<span className='priceSmall rating'>{ score }</span> out of 5)</span>
      </p>
    )
  }
}

ReviewItem.propTypes = {
  item: object.isRequired,
  lang: string,
  search: string
}

ReviewItem.defaultProps = {
  lang: 'en'
}

export default ReviewItem



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviewItem.jsx